// Quote.js
import React from "react";

const Quote = ({ description, rate, qty, weightAfterWastage, type }) => {
  return (
    <div
      id="report"
      style={{
        maxWidth: "800px",
        margin: "0 auto",
        padding: "30px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Header Section with Logo and Title */}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderBottom: "2px solid #ddd",
          paddingBottom: "15px",
          marginBottom: "30px",
        }}
      >
        <div style={{ flex: "0 0 130px", marginRight: "20px" }}>
          <img
            src="/logowname.png" // Replace with your logo path
            alt="Company Logo"
            style={{ width: "100%", height: "auto" }}
          />
        </div>
        <div style={{ flex: "1" }}>
          <h1
            style={{
              fontSize: "28px",
              fontWeight: "600",
              color: "#333",
              margin: "0",
            }}
          >
            Quotation
          </h1>
          <p style={{ fontSize: "16px", color: "#777" }}>
            Heavy Quality, Light on Wallet.
          </p>
        </div>
      </div>

      {/* Table Section */}
      <div style={{ width: "100%", marginBottom: "20px" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "20px",
            textAlign: "left",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  borderBottom: "1px solid #ddd",
                  padding: "12px",
                  fontSize: "18px", // Slightly larger font size for better readability
                  color: "#333",
                  fontWeight: "700", // Bold header text
                  textAlign: "left", // Align description to the left for consistency
                  backgroundColor: "#f4f4f4", // Light background to differentiate header
                }}
              >
                Description
              </th>
              <th
                style={{
                  borderBottom: "1px solid #ddd",
                  padding: "12px",
                  fontSize: "18px", // Slightly larger font size for better readability
                  color: "#333",
                  fontWeight: "700", // Bold header text
                  textAlign: "center", // Align quantity to the center
                  backgroundColor: "#f4f4f4", // Light background to differentiate header
                }}
              >
                Qty
              </th>
              <th
                style={{
                  borderBottom: "1px solid #ddd",
                  padding: "12px",
                  fontSize: "18px", // Slightly larger font size for better readability
                  color: "#333",
                  fontWeight: "700", // Bold header text
                  textAlign: "right", // Align rate to the right for consistency
                  backgroundColor: "#f4f4f4", // Light background to differentiate header
                }}
              >
                Rate/{type}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  color: "#555",
                  width: "50%", // Ensure this column takes up 50% of the width
                }}
              >
                {description}
                {type === "Tube" || type === "Bag"
                  ? ""
                  : ` ${type} Weight: ${weightAfterWastage.toFixed(2)} KG`}
              </td>
              <td
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  color: "#555",
                  width: "25%", // Ensure this column takes up 25% of the width
                  textAlign: "center", // Center the content
                }}
              >
                {qty}
              </td>

              <td
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  color: "#555",
                  width: "25%", // Ensure this column takes up 25% of the width
                  textAlign: "right", // Align rate to the right for better readability
                }}
              >
                ₹ {rate.toFixed(2)}/{type}
              </td>
            </tr>

            <tr>
              <td
                style={{
                  padding: "12px", // Slightly increased padding for better spacing
                  fontSize: "16px",
                  color: "#555",
                  fontWeight: "700", // Make "Total" bold for emphasis
                  textAlign: "left", // Align to the left for consistency with the description
                  backgroundColor: "#f4f4f4", // Light background to differentiate total row
                }}
              >
                Total
              </td>
              <td
                style={{
                  padding: "12px",
                  fontSize: "16px",
                  color: "#555",
                  backgroundColor: "#f4f4f4",
                  textAlign: "center", // Center align for consistency with "Qty"
                }}
              ></td>
              <td
                style={{
                  padding: "12px",
                  fontSize: "16px",
                  color: "#555",
                  textAlign: "right", // Align rate to the right
                  fontWeight: "700", // Make total price bold
                  backgroundColor: "#f4f4f4", // Light background to differentiate total row
                }}
              >
                ₹ {(qty * rate).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Cost Excluding GST Section */}
      <div
        style={{
          width: "100%",
          padding: "10px",
          backgroundColor: "#f9f9f9",
          borderRadius: "5px",
          textAlign: "center",
          fontSize: "18px",
          color: "#333",
          fontWeight: "500",
        }}
      >
        <p>
          <b>Cost including GST (12%):</b> ₹ {(rate * qty * 1.12).toFixed(2)}
        </p>
      </div>

      {/* Footer Section */}
      <div
        style={{
          borderTop: "2px solid #ddd",
          paddingTop: "15px",
          textAlign: "center",
          marginTop: "30px",
        }}
      >
        <p style={{ fontSize: "14px", color: "#888" }}>
          Thank you for considering our services. For more details or
          adjustments, feel free to contact us.
        </p>
        <p style={{ fontSize: "14px", color: "#888" }}>
          © 2024 GD Enterprise. All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default Quote;
